import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Footer.css'
import { faFacebook, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'

function Footer() {
 return (
    <div id={"footer"} className='centered'>
        <div className='footer-container'>
            <div className='footer-image-container'>
                <img src='/images/footer-image.jpg' alt='Trisha Somers' id='footer-image'/>
                <div className='footer-text'>
                    <p>I help people calm their mind, clear mental noise, and release what’s weighing on them, so they can see their next step with clarity and confidence.</p>
                </div> 
            </div>
            <div>
                <h4>Connect with me</h4>
                <div className='icon-container'>
                    <a href="https://www.linkedin.com/in/trishasomers" target='_blank' rel='noreferrer' className="footer-logo">
                        <FontAwesomeIcon icon={faLinkedin} className='contact-icon' />
                    </a>
                    <a href="mailto:trisha@trishasomers.com" target='_blank' rel='noreferrer' className="footer-logo"> 
                        <FontAwesomeIcon icon={faEnvelope} className='contact-icon' />
                    </a>
                    <a href="https://www.instagram.com/trisha_somers_coaching" target='_blank' rel='noreferrer' className="footer-logo"> 
                        <FontAwesomeIcon icon={faInstagram} className='contact-icon' />
                    </a>
                    <a href="https://www.facebook.com/TrishaSomersCoaching" target='_blank' rel='noreferrer' className="footer-logo"> 
                        <FontAwesomeIcon icon={faFacebook} className='contact-icon' />
                    </a>
                </div>
            </div>
            <div className='certifications-section'>
                <img src='/images/designations/icf.png' alt='Trisha Somers' id='footer-image'/>
                <img src='/images/designations/disc.png' alt='Trisha Somers' id='footer-image'/>
            </div>
        </div>
    </div>
 )
}

export default Footer